export default "__VITE_ASSET__67204ccd__"